import { Box } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';

const DefaultSkeleton = () => {
  return (
    <Box padding="32px 24px">
      <SkeletonComponent height="30vh" width="100%" mb="20px" />
      <SkeletonComponent height="30vh" width="100%" />
    </Box>
  );
};

export default DefaultSkeleton;
